import { Wackerneuson } from './wackerneuson/wackerneuson';
import { Osp } from './osp/osp';
import { environment } from '../environments/environment';
import { Whitelabel } from '../app/whitelabel/contract/whitelabel.contract';
import { AppVersions } from '../app/shared/enums/quick-links-for.enum';

export const WHITELABEL_CONFIGURATION: Record<AppVersions, Whitelabel> = {
  [AppVersions.OSP]: Osp,
  [AppVersions.WN]: Wackerneuson,
};

export const whitelabelIdentifier = environment.APP_VERSION;
